import { Injectable } from '@angular/core';
import Cookies from 'js-cookie';

const COOKIE_NAME = 'Swopyn-AUTH-TOKEN';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  getSession(): any | null {
    try {
      const session = Cookies.get(COOKIE_NAME);
      return session ? JSON.parse(session) as any : null;
    } catch (error) {
      return null;
    }
  }

  setSession(session: any): boolean {
    try {
      Cookies.set(COOKIE_NAME, JSON.stringify(session), { expires: 30 });
      return true;
    } catch (error) {
      return false;
    }
  }

  clearSession(): boolean {
    try {
      Cookies.remove(COOKIE_NAME);
      return true;
    } catch (error) {
      return false;
    }
  }
}
